import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Nav, NavbarBrand, NavbarToggler, NavItem, InputGroup, NavLink, Input, Badge, Button } from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';
import { logout } from '../../actions/AuthenticationActions';
import { showbar } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { console_log, appendUid } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';
import { config } from '../../constants/domainConfig';
import { isGamiclub } from '../../constants/isGamiclub';
import { isOnlyBeemobi } from '../../constants/isOnlyBeemobi';
import { isAppspool } from "../../constants/isAppspool";
import { isTheGamingClubs } from '../../constants/isTheGamingClubs';
import { isGamezClan } from '../../constants/isGamezClan';
import { isOnlyMobbfun } from '../../constants/isOnlyMobbfun';
import { isGameflares, isGamiway } from '../../constants/productCondition';

const arabicDomain = (config.lang == 'ar') ? true : false;
const frenchDomain = (config.lang == 'fr') ? true : false;
const kazakhDomain = (config.lang == 'kk') ? true : false;
const norwayDomain = (config.lang == 'no') ? true : false;
const swedishDomain = (config.lang == 'sv') ? true : false;
const turkeyDomain = (config.lang == 'tr') ? true : false;
const spanishDomain = (config.lang == 'es') ? true : false;

class Header extends Component {

    constructor(props) {
        super(props);

        this.searchOpen = this.searchOpen.bind(this);

        this.onSearchTextChange = this.onSearchTextChange.bind(this);
        this.clearText = this.clearText.bind(this);
    }

    sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
    }

    mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
    }

    redirectToWelcome(e) {
        if (!document.body.classList.contains('sidebar-hidden')) {
            document.body.classList.toggle('sidebar-hidden');
        }
        if (document.body.classList.contains('sidebar-mobile-show')) {
            document.body.classList.toggle('sidebar-mobile-show');
        }
    }
    // searchOpen() {
    //     debugger
    //     this.props.showbar(!this.props.header.showSearchBar);
    //     let searchInput = document.querySelector("#search-input");
    //     if (!this.props.header.showSearchBar) {
    //         searchInput.focus();
    //     } else {
    //         searchInput.blur();
    //     }
    //     this.clearText();
    // }

    componentDidMount() {
        this.hideSearchBar();
    }
    clearText() {
        this.props.searchText('');
    }
    onSearchTextChange(text) {
        this.props.searchText(text);
    }
    hideSearchBar() {
        let currentThis = this;
        document.querySelector(".app-body").addEventListener("click", function (e) {
            if (e.target.classList.contains("custom-star")) {
            }
            else {
                const searchContainer = document.querySelector("#search-container");
                const searchInput = document.querySelector("#search-input");
                searchContainer.classList.remove("search-toggle");
                if (searchContainer.classList.contains('search-toggle')) {
                    searchInput.focus();
                } else {
                    searchInput.blur();
                }
            }

        });
    }
    searchOpen() {
        this.clearText();
        this.props.showbar(!this.props.header.showSearchBar);
        const searchContainer = document.querySelector("#search-container");
        const searchInput = document.querySelector("#search-input");
        const navbar = document.querySelector("#navbar");
        const navbarLeft = document.querySelector("#navbar-left");
        searchContainer.classList.toggle("search-toggle");
        navbar.classList.toggle("search-toggle");
        navbarLeft.classList.toggle("search-toggle");
        document.body.classList.toggle('hamburger-menu-hidden');
        if (searchContainer.classList.contains('search-toggle')) {
            searchInput.focus();
        } else {
            searchInput.blur();
        }
    }
    handleChange(event) {
        this.props.changeLang(event.target.value);
        this.setState({})
    };

    render() {
        (this.props.currentLang == 'ar') ? document.body.classList.add("ar") : document.body.classList.add("other")
        const isAdmin = this.props.user.isAdmin;
        let showSearch = true;
        let maxis_email;

        if (this.props.pathName.indexOf('/welcome') != -1 || this.props.pathName.indexOf('/search') != -1 || this.props.pathName.indexOf('/account') != -1 || this.props.pathName.indexOf('/restricted') != -1) {
            showSearch = false;
        }

        if (sessionStorage.getItem('maxis_email')) {
            maxis_email = sessionStorage.getItem('maxis_email');
        }

        return (
            <header id='navbar' className={(this.props.currentLang == 'ar') ? 'app-header navbar ar' : isGameflares ? 'app-header navbar gameflares_bg': "app-header navbar other"}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12">
                            {(this.props.pathName.indexOf('/restricted') != -1) ? '' :
                                <div id='navbar-left' className={`navbar-left ${isGameflares ? 'gameflares_bg':''}`}>
                                    {window.location.hostname.includes('vplay') ? null : !this.props.pathName.includes("maxis") && <NavbarToggler className={`d-lg-none ${isGameflares ? 'gameflares_bg':''}`} onClick={this.mobileSidebarToggle}>
                                        <span><i style={isGamiclub ? { color: 'green' } : isGameflares ? { color:'#FF394B'} : isGamiway ? {color:'#b347a0'} :null} className="icon-menu menu-icon"></i></span>
                                    </NavbarToggler>}
                                    {window.location.hostname.includes('vplay') ? null : !this.props.pathName.includes("maxis") && < NavbarToggler className={`d-md-down-none desktop-menuicon ${isGameflares ? 'gameflares_bg':''}`} onClick={this.sidebarToggle}>
                                        <span><i style={isGamiclub ? {color: 'green'} : isGameflares ? { color:'#FF394B'} :isGamiway ? {color:'#b347a0'} : null} className="icon-menu menu-icon"></i></span>
                                    </NavbarToggler>}
                                    {(this.props.pathName.indexOf('/account') != -1) ?
                                        ''
                                        :
                                        <NavbarBrand
                                        className={isOnlyMobbfun ? 'navbar-brand-mobbfun' : isGameflares ? 'navbar-brand-gameflares':undefined}  
                                        style={
                                            isGamiclub ?
                                            ( isOnlyBeemobi ? { backgroundImage:  "url('../img/logo-beemobi.png')" } : isOnlyMobbfun ? { backgroundImage:  "url('../img/logo-mobbfun.png')" } : this.props.pathName.includes("maxis") ? { backgroundImage: "url('../img/logo-gamiclub.png')", marginLeft: "12px" } : this.props.pathName.includes("maxis") ? { backgroundImage: "url('../img/logo-gamiclub.png')", marginLeft: "12px" } : { backgroundImage: "url('../img/logo-gamiclub.png')" } )
                                            :
                                            isAppspool ?
                                            { backgroundImage: `url('../img/logo-appspool.png')` }
                                            :
                                            isTheGamingClubs ?
                                            { backgroundImage: `url('../img/gamingclub_logo.svg')` }
                                            :
                                            isGamezClan ?
                                            { backgroundImage: `url('../img/logo-gamezclan.png')` }
                                            :
                                            isGameflares ?
                                            { backgroundImage: `url('../img/gameflares-white.svg')`, backgroundPositionY:'2px' }
                                            :     
                                            isGamiway ?
                                            {  backgroundImage: `url('../img/gamiway/gamiway.png')`, backgroundPositionY:'2px' }  
                                            :
                                            window.location.hostname.includes('vplay') ?
                                            {  backgroundImage: `url('../img/VPlay_Logo.svg')`, marginLeft:'15%' }
                                            : null
                                        } 
                                        href={swedishDomain || config.subDomain == 'th' || config.subDomain == 'rsma' || (window.location.hostname.includes('game-lords.com') && config.subDomain === 'ae') || window.location.hostname.includes('vplay') ? appendUid("#/home/html", this.props.access.uid) : config.subDomain == 'pk' ? appendUid("#/home/android", this.props.access.uid) : window.location.href.includes("maxis") ? "/#/demo-maxis" : appendUid("#/welcome", this.props.access.uid)} onClick={this.redirectToWelcome}>
                                            
                                        </NavbarBrand>
                                    }
                                </div>}
                            
                            {(this.props.pathName.indexOf('/account') != -1 || (config.subDomain === "es" && this.props.pathName.indexOf('/welcome') >= 0 && screen.width > 768)) ?
                                <h2 className="page-title white-text-color">{this.props.header.title}</h2>
                                : <span></span>

                            }
                            
                            {window.location.href.includes("maxis") ?
                                <h2 className="page-title white-text-color maxis-login">{sessionStorage.getItem('maxis_email') ? "Hello " + sessionStorage.getItem('maxis_email') : <a href="#" onClick={(e) => {e.preventDefault(); if (this.props.onLoginClick) this.props.onLoginClick();}}>Signup/Login</a>}</h2>
                                : <span></span>
                            }



                            {window.location.hostname.includes('vplay') ? null : !this.props.pathName.includes("maxis") && <Nav className="navbar search-wrap">
                                {isAdmin ?
                                    <HeaderDropdown logout={this.props.logout} />
                                    : (showSearch) ?
                                        <NavItem id="search-container" className="d-md-down-none search-container search">
                                            <NavLink className={(arabicDomain) ? 'search-button ar' : "search-button"} id="search-button" onClick={this.searchOpen}>
                                                {isGamiclub ? <img className="icon-magnifier menu-icon search-icon" src="./img/gamiclub/search.png" />
                                                : isGameflares ? <img  className="icon-magnifier menu-icon search-icon" src='./img/gameflares/magnifying-glass.png'/>
                                                : isGamiway ? <img  className="icon-magnifier menu-icon search-icon" src ="./img/gamiway/search.png"/>
                                                : <img className="icon-magnifier menu-icon search-icon" src="./img/icons/search-icon.png" />}
                                            </NavLink>
                                            {/*<NavLink id="search-button" href="#/search"><img className="icon-magnifier menu-icon search-icon" src="./img/icons/search-icon.png" /></NavLink>*/}
                                            <FormattedMessage
                                                defaultMessage="Search..."
                                                id='search.input.placeholder'>
                                                {placeholder => <Input style={isGamiclub ? {borderColor: 'green'} : isGameflares ? {borderColor: '#FF394B'} :isGamiway ? {borderColor:'#b347a0'} : null} onChange={e => this.onSearchTextChange(e.target.value)} placeholder={placeholder} id="search-input" className="search-input" type="search" value={this.props.search.searchText} />}
                                            </FormattedMessage>
                                            {/* <input id="search-input" className="search-input" type="search" placeholder={searchText} value={this.props.search.searchText} onChange={this.onChange}/> */}
                                            <button className="search-clear" onClick={this.clearText}>
                                                {isGamiclub || isGameflares || isGamiway ? <i className={`fa fa-times ${isGameflares ? 'fa-gradient-gameflares' :isGamiway ? 'fa-gradient-gamiway':'fa-gradient-gamiclub'}`} style={{fontSize: '18px'}} aria-hidden="true"></i>
                                                : <img src="./img/icons/clear.svg" />}
                                            </button>
                                            <button style={isGamiclub ? {color: 'green'} : isGameflares ? {color: '#FF394B'}: isGamiway ? {color:'#b347a0'}: null} className="search-cancel" onClick={this.searchOpen}>
                                                <FormattedMessage id="search.cancel.button"
                                                    defaultMessage="Cancel"
                                                /></button>
                                        </NavItem>
                                        : ''
                                }
                            </Nav>}

                        </div>
                    </div>
                </div>
                { /* ( arabicDomain || frenchDomain) && (this.props.pathName.indexOf('/welcome')>=0) ?
                <div className={(this.props.currentLang == 'ar') ? 'arabicLangDropDown' : 'otherlangDropDown'}>
                    <select onChange={this.handleChange.bind(this)}>
                    <option value="ar" selected={(this.props.changeLang == 'ar') ? 'selected' : ''}>ar</option>
                        <option value="fr" selected={(this.props.changeLang == 'fr') ? 'selected' : ''}>fr</option>
                    </select>
                            </div> : null */ }
            </header>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        header: state.HeaderReducer,
        search: state.SearchReducer,
        access: state.WelcomeReducer


    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        logout,
        searchText,
        showbar,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js